
import {Component, Vue} from 'vue-property-decorator'
import UserGroupInfo from '@/model/modules/UserGroupInfo'
import UserGroupService from '@/service/modules/UserGroupService'

@Component
export default class UserLevelGroupEditor extends Vue {
  item: UserGroupInfo = new UserGroupInfo()
  showState: boolean = false
  savingState: boolean = false
  saveSuccessCallback: any

  showEditor(item: UserGroupInfo, saveSuccessCallback: any) {
    this.item = JSON.parse(JSON.stringify(item))
    this.saveSuccessCallback = saveSuccessCallback
    this.showState = true
  }

  saveEditor() {
    this.savingState = true
    if (this.item.id === 0) {
      delete this.item.id
    }
    UserGroupService.save(this.item)
      .then(() => {
        this.$alert('保存数据', '保存成功', {
          confirmButtonText: '确定'
        })
        this.savingState = false
        this.showState = false
        this.saveSuccessCallback()
      })
  }
}
